import { ShadowStyles } from './ShadowConstants';

export const DialogMainStyles = {
  main: {
    borderRadius: '8px',
    boxShadow: ShadowStyles.shadowLevel6
  }
};

export const dialogButtonStyles = {
  borderRadius: '4px',
  boxShadow: ShadowStyles.shadowLevel4,
  border: 'none'
};
